import { styled } from '@mui/material';
import ThemeTypography from 'DesignSystem/Primitives/Typography/ThemeTypography';
import React, { FC } from 'react';
import { formatAndRoundNumber } from 'utils/number.utils';

interface ISummaryBadgeProps {
  value: number;
  /**
   * Name of the value to be displayed. An s will be appended for pluralization if value > 1.
   */
  name: string;

  /**
   * @default 0
   */
  decimalPlaces?: number;
}

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  height: 30,
  padding: '4px 8px',
  alignItems: 'center',
  backgroundColor: theme.custom.themeColors.white,
  borderRadius: 4,
}));

const SummaryBadge: FC<ISummaryBadgeProps> = ({ value, name, decimalPlaces = 0 }) => {
  return (
    <Container>
      <ThemeTypography variant="BODY_SMALL_BOLD" color="GRAY_100">
        {formatAndRoundNumber(value, decimalPlaces)} {name}
        {value !== 1 ? 's' : ''}
      </ThemeTypography>
    </Container>
  );
};

export default SummaryBadge;
